import { Button, CircularProgress, IconButton, Fade, Grid, Tooltip } from '@material-ui/core';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import Badge from '@material-ui/core/Badge';
import { blue, grey } from '@material-ui/core/colors';
import Add from '@material-ui/icons/Add';
import DraftsIcon from '@material-ui/icons/Drafts';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useDispatch } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Link, useHistory } from 'react-router-dom';
import Url from 'url';
import axios from '../../axios-default';
import { easySnackbar } from '../../store/Noti/noti.actions';
import { useLang } from '../../util/lang';
import '../../util/object';
import '../../util/string';
import '../../util/array';
import style from '../../pages/css/patients.module.css';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { getWebAbsPath } from '../../util/path';
import useAuth from '../../hooks/useAuth';
import { usePatientsStyles } from '../../style/usePatientsStyles';

const GridView = forwardRef((props, ref) => {
    const auth = useAuth();
    const get = useLang('Patients');
    const getPages = useLang('pages');
    const classes = usePatientsStyles(),
        dispatch = useDispatch(),
        history = useHistory();

    const [pageNo, setPageNo] = useState(0),
        [pageSize] = useState(15),
        [total, setTotal] = useState(0),
        [data, setData] = useState([]),
        [loading, setLoading] = useState(true),
        [gridArchiveconfirm, setgridArchiveconfirm] = useState(false);
    const [gridUnarchiveConfirm, setGridUnarchiveConfirm] = useState(false);
    const lastSearchStr = useRef(props.searchStr),
        debounceTimer = useRef(),
        cat = useRef(localStorage.getItem('Patients.cat') || 'ALL'),
        role = useRef(auth.user.role);
    const [selectedCase, setSelectedCase] = useState(null);

    useEffect(() => {
        dataSetter(pageNo, lastSearchStr.current)();
    }, []);

    const reloadGrid = () => {
        history.push('/blank');
        history.replace(`/`);
    };
    const handleGridArchive = async () => {
        try {
            const archiveTargetCaseId = selectedCase?.case_id;
            if (!archiveTargetCaseId) throw new Error('Invalid target case id');
            await axios.post(`case/${archiveTargetCaseId}/archived`);
            dispatch(easySnackbar('Case Archived', 'success'));
            reloadGrid();
        } catch (err) {
            console.error(err);
        }
    };

    const handleGridUnarchive = async () => {
        try {
            const unarchiveTargetCaseId = selectedCase?.case_id;
            if (!unarchiveTargetCaseId) throw new Error('Invalid target case id');
            if (unarchiveTargetCaseId === null) {
                throw new Error('Target case id is null');
            }
            await axios.post(`case/${unarchiveTargetCaseId}/archived/undo`);
            dispatch(easySnackbar('Case Unarchived', 'success'));
            reloadGrid();
        } catch (err) {
            console.error(err);
            dispatch(easySnackbar(err.message ?? err, 'error'));
        }
    };
    const handleClickOpen = (e, action, v) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedCase(v);
        if (action === 'archive') {
            setgridArchiveconfirm(true);
        } else {
            setGridUnarchiveConfirm(true);
        }
    };

    const handleClose = (action) => {
        setSelectedCase(null);
        if (action === 'archive') {
            setgridArchiveconfirm(false);
        } else {
            setGridUnarchiveConfirm(false);
        }
    };
    const getData = useCallback(() => {
        return loading ? data.concat(new Array(4 - (data.length % 4)).fill(null)) : data;
    }, [loading, data]);

    const dataSetter =
        (_pageNo, search = {}) =>
        async () => {
            if (data.length < total || !_pageNo) {
                try {
                    const {
                        data: newData,
                        page,
                        totalCount,
                    } = await Promise.resolve(
                        props.data({
                            page: _pageNo,
                            pageSize: pageSize,
                            search,
                            statusFilter: cat.current,
                            orderBy: { field: 'unread_changes_count' },
                            orderDirection: 'desc',
                        })
                    );
                    if (page) {
                        setData([...data, ...newData]);
                    } else {
                        setData(newData);
                    }
                    setPageNo(page);
                    setTotal(totalCount);
                } catch (err) {
                    console.error(err);
                }
            }
            setLoading(false);
        };

    const loadMore = () => {
        setLoading(true);
        dataSetter(pageNo + 1, lastSearchStr.current)();
    };
    useBottomScrollListener(loadMore);

    useImperativeHandle(ref, () => ({
        onSearchChangeDebounce(searchStr) {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
            }
            debounceTimer.current = setTimeout(dataSetter(0, searchStr), 700);
        },
        onQueryChange(_cat) {
            cat.current = _cat;
            dataSetter(0, '')();
        },
    }));

    return (
        <>
            {getData().map((v, i) => (
                <Fade in={true} timeout={1000} key={`case${i}`}>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={3}
                        style={{
                            padding: 8,
                            display: 'block',
                            transition: 'display 2s ease-in-out',
                            transitionDelay: '1s',
                        }}
                    >
                        {v !== null ? (
                            <Link
                                to={
                                    v.case_status == 'DRAFT'
                                        ? `/patients/${v.patient_id}/${v.case_id}/edit${v.new_case_option ? `/${v.new_case_option}` : ''}`
                                        : `/patients/${v.case_id}`
                                }
                                style={{
                                    color: 'unset',
                                    textDecoration: 'none',
                                }}
                            >
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        className={classes.listCard}
                                        style={{
                                            borderLeft: ['DRAFT', 'AWAITING', 'PLAN_UPLOADED'].includes(
                                                v.case_status.toUpperCase()
                                            )
                                                ? 'solid 6px #ffb961'
                                                : v.case_status.toUpperCase() === 'ENDED'
                                                  ? 'solid 6px grey'
                                                  : 'solid 6px #ff6161',
                                            borderRadius: '4px',
                                            background: 'white',
                                        }}
                                    >
                                        <Grid container>
                                            <Grid item xs={6}>
                                                <img
                                                    crossOrigin="use-credentials"
                                                    src={v.profile_pic}
                                                    className={classes.gridIcon}
                                                    onError={(e) => {
                                                        let u = Url.parse(e.target.src);
                                                        e.target.src =
                                                            u.pathname === '/' || u.pathname.startsWith('/img')
                                                                ? ''
                                                                : v.gender === 'M'
                                                                  ? getWebAbsPath('/img/maleIcon.png')
                                                                  : v.gender === 'F'
                                                                    ? getWebAbsPath('/img/femaleIcon.png')
                                                                    : getWebAbsPath('/img/otherIcon.png');
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6} style={{ padding: 4 }}>
                                                <p style={{ fontWeight: 600 }}>{v.first_name + ', ' + v.last_name}</p>
                                                <p style={{ fontSize: 14 }}>{`(#${v.case_id})`}</p>
                                            </Grid>

                                            <hr style={{ border: 'solid 1px #ededed', width: '100%' }} />

                                            <Grid item xs={6}>
                                                <p style={{ fontWeight: 600 }}>
                                                    {get('case_list.columns.treatmentOption')}
                                                </p>
                                                <p style={{ fontSize: 14 }}>{`${v.case_type_label}`}</p>
                                            </Grid>
                                            <Grid item xs={3} style={{ textAlign: 'center', alignSelf: 'center' }}>
                                                <Badge
                                                    className={style.customBadge}
                                                    badgeContent={
                                                        ['DR', 'NR'].includes(role.current)
                                                            ? v.unread_status_changes_count +
                                                                  v.unread_chat_changes_count ===
                                                              0
                                                                ? null
                                                                : `${v.unread_status_changes_count}+${v.unread_chat_changes_count}`
                                                            : ['DISTR'].includes(role.current)
                                                              ? v.unread_status_changes_count +
                                                                    v.unread_chat_changes_count +
                                                                    (v.unread_private_chat_changes_count || 0) ===
                                                                0
                                                                  ? null
                                                                  : `${v.unread_status_changes_count}+${v.unread_chat_changes_count}+${typeof v.unread_private_chat_changes_count === 'number' && v.unread_private_chat_changes_count}`
                                                              : v.unread_status_changes_count +
                                                                      v.unread_chat_changes_count +
                                                                      (v.unread_private_chat_changes_count || 0) +
                                                                      (v.unread_intl_chat_changes_count || 0) ===
                                                                  0
                                                                ? null
                                                                : `${v.unread_status_changes_count}+${v.unread_chat_changes_count}+${typeof v.unread_private_chat_changes_count === 'number' ? v.unread_private_chat_changes_count : 0}+${typeof v.unread_intl_chat_changes_count === 'number' ? v.unread_intl_chat_changes_count : 0}`
                                                    }
                                                >
                                                    {v.unread_status_changes_count +
                                                        v.unread_chat_changes_count +
                                                        (['DR', 'NR'].includes(role.current)
                                                            ? 0
                                                            : v.unread_private_chat_changes_count) +
                                                        (['ADMIN', 'SADMIN'].includes(role.current)
                                                            ? v.unread_intl_chat_changes_count
                                                            : 0) ===
                                                    0 ? (
                                                        <DraftsIcon />
                                                    ) : (
                                                        <MailOutlinedIcon />
                                                    )}
                                                </Badge>
                                            </Grid>
                                            {cat.current !== 'ARCHIVED' && ['DR', 'NR'].includes(role.current) ? (
                                                <Grid item xs={3} style={{ textAlign: 'center', alignSelf: 'center' }}>
                                                    <>
                                                        <IconButton onClick={(e) => handleClickOpen(e, 'archive', v)}>
                                                            <Tooltip
                                                                title={getPages('paitents.markarchive')}
                                                                placement="top"
                                                            >
                                                                <ArchiveIcon style={{ color: '#212121' }}></ArchiveIcon>
                                                            </Tooltip>
                                                        </IconButton>
                                                    </>
                                                </Grid>
                                            ) : (
                                                <>
                                                    <IconButton onClick={(e) => handleClickOpen(e, 'unarchive', v)}>
                                                        <Tooltip title="Unarchive" placement="top">
                                                            <UnarchiveIcon style={{ color: '#212121' }}></UnarchiveIcon>
                                                        </Tooltip>
                                                    </IconButton>
                                                </>
                                            )}
                                            <Grid item xs={12}>
                                                <p style={{ fontWeight: 600 }}>{get('case_list.columns.caseStatus')}</p>
                                                <p style={{ fontSize: 14 }}>{v.case_status_label}</p>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <p style={{ fontWeight: 600 }}>{get('case_list.columns.drName')}</p>
                                                <p style={{ fontSize: 14 }}>{`${v.doctor_name}`}</p>
                                            </Grid>
                                            {['ADMIN', 'SADMIN', 'DISTR'].includes(role.current) && (
                                                <Grid item xs={12}>
                                                    <p style={{ fontWeight: 600 }}>
                                                        {get('case_list.columns.refCode')}
                                                    </p>
                                                    <p style={{ fontSize: 14 }}>{`${v.refCode}`}</p>
                                                </Grid>
                                            )}
                                            {['ADMIN', 'SADMIN', 'DISTR'].includes(role.current) && (
                                                <Grid item xs={12}>
                                                    <p style={{ fontWeight: 600 }}>
                                                        {get('case_list.columns.clientCode')}
                                                    </p>
                                                    <p style={{ fontSize: 14 }}>{`${v.clientCode}`}</p>
                                                </Grid>
                                            )}
                                            <Grid item xs={12}>
                                                <p style={{ fontWeight: 600 }}>
                                                    {get('case_list.columns.submissionDate')}
                                                </p>
                                                <p style={{ fontSize: 14 }}>{`${v.submission_date}`}</p>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <p style={{ fontWeight: 600 }}>
                                                    {get('case_list.columns.approvalDate')}
                                                </p>
                                                <p style={{ fontSize: 14 }}>{`${v.approval_date}`}</p>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Link>
                        ) : (
                            <Grid
                                container
                                item
                                xs={12}
                                className={classes.listCard}
                                style={{
                                    minHeight: 400,
                                    borderLeft: 'solid 6px #888888',
                                    borderRadius: '4px',
                                    backgroundColor: grey[200],
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                                justify="center"
                                alignItems="center"
                            >
                                <CircularProgress style={{ color: blue[400] }} />
                            </Grid>
                        )}
                    </Grid>
                </Fade>
            ))}
            <Dialog open={gridArchiveconfirm} onClose={() => handleClose('archive')}>
                <DialogContent>
                    <DialogContentText>Do you want to Archive this case?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose('archive')}>No</Button>
                    <Button onClick={() => handleGridArchive()}>Yes</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={gridUnarchiveConfirm} onClose={() => handleClose('unarchive')}>
                <DialogContent>
                    <DialogContentText>Do you want to Unarchive this case?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleClose('unarchive')}>No</Button>
                    <Button onClick={() => handleGridUnarchive()}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Button
                fullWidth
                style={{
                    display: data.length < total ? undefined : 'none',
                    heigth: 5,
                    marginTop: 5,
                    backgroundColor: grey[300],
                }}
                onClick={() => loadMore()}
            >
                <Add color="white" />
            </Button>
        </>
    );
});

export default GridView;
